import React from 'react';
import { connect } from 'react-redux';
import { PatientCareCenterNoteSection } from 'PatientCareCenter/Note';
import styles from './Common.module.css';
import { getPanels } from '_helpers';
import { PatientCareCenterNoteObjectiveStrPanel } from './StrPanel';
import { DBCheckBoxObjective } from '_components';
import { StrComments } from './StrComments';
import { StrengthHandTemplate } from './StrengthHandTemplate';


class PatientCareCenterNoteObjectiveStr extends React.Component {

    render() {
        return (
            <span>
                {this.props.panels.length > 0 &&
                    <PatientCareCenterNoteSection id='obj_str' name='Strength' level={1}>
                        <div className={styles.row}>
                            <div className={styles.flag} />
                            <DBCheckBoxObjective
                                noteId={this.props.noteId}
                                entity='PTOBJECTIVESTR'
                                entityKeyColumn='STNO'
                                entityKeyValue={this.props.stno}
                                field='STNOTTESTED'
                                className={styles.checkbox}
                                label='Not tested at this time'
                            />
                        </div>

                        {!this.props.notTested &&
                            <span>
                                <div className={styles.row}>
                                    <div className={styles.flag} />
                                    <div className={styles.label} />
                                    <div className={styles.str_header}>Strength</div>
                                </div>

                                <div className={styles.row}>
                                    <div className={styles.flag} />
                                    <div className={styles.label} />
                                    <div className={styles.r_header}>R</div>
                                    <div className={styles.c_header} />
                                    <div className={styles.l_header}>L</div>
                                </div>


                                {
                                    Object.keys(this.props.panels)
                                        .map(key => {
                                            return (<PatientCareCenterNoteObjectiveStrPanel key={this.props.panels[key].MOPNO} panelId={this.props.panels[key].MOPNO} />);
                                        })

                                }
                            </span>
                        }
                        <StrComments />
                        {this.props.isHandSelected &&
                            <StrengthHandTemplate />
                        }

                    </PatientCareCenterNoteSection>
                }
            </span>
        );
    }

}

function mapStateToProps(state) {
    let noteId = state.ui.patientTabs[state.ui.patientCenter[state.ui.patients.selectedPtno].selectedTab].noteId;
    let noteType = parseInt(noteId.split("_")[0]);
    let pk = parseInt(noteId.split("_")[1]);
    let stno = parseInt(Object.keys(state.entities.notes.PTOBJECTIVESTR)
        .find(key => (state.entities.notes.PTOBJECTIVESTR[key].STEVNO === pk && noteType === 1)
            || (state.entities.notes.PTOBJECTIVESTR[key].STNTNO === pk && noteType !== 1)));

    let notTested = state.entities.notes.PTOBJECTIVESTR[stno].STNOTTESTED;

    let isHandSelected = Object.keys(state.entities.notes.PTOBJECTIVETEMPLATESXREF)
        .filter(key => {
            return (noteType === 1 && state.entities.notes.PTOBJECTIVETEMPLATESXREF[key].OBEVNO === pk && state.entities.notes.PTOBJECTIVETEMPLATESXREF[key].OBTENO == 16) ||
                (noteType !== 1 && state.entities.notes.PTOBJECTIVETEMPLATESXREF[key].OBNTNO === pk && state.entities.notes.PTOBJECTIVETEMPLATESXREF[key].OBTENO == 16)
        }).length > 0 ? true : false;

    return {
        noteId: noteId,
        panels: getPanels(noteId, 'Strength'),
        stno: stno,
        notTested: notTested,
        isHandSelected
    };
}

const connectedPatientCareCenterNoteObjectiveStr = connect(mapStateToProps)(PatientCareCenterNoteObjectiveStr);
export { connectedPatientCareCenterNoteObjectiveStr as PatientCareCenterNoteObjectiveStr };

